import { render, staticRenderFns } from "./SensorErgebnis.vue?vue&type=template&id=1a8fbe72&scoped=true"
import script from "./SensorErgebnis.vue?vue&type=script&lang=js"
export * from "./SensorErgebnis.vue?vue&type=script&lang=js"
import style0 from "./SensorErgebnis.vue?vue&type=style&index=0&id=1a8fbe72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8fbe72",
  null
  
)

export default component.exports